























































































































































































































































































































































































































































































import moment from "moment/moment";
import Component, { mixins } from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { Site } from "@/shared/Site";
import { Groupe } from "@/shared/Groupe";
import DateChooser from "@/components/dateChooser.vue";
import RapportSelection from "@/components/rapportSelection.vue";
import ListeSites from "@/components/listeSites.vue";
import LocalChooser from "@/components/localChooser.vue";
import PdfViewer from "@/components/pdf-viewer.vue";
import PdfReport from "@/shared/pdfReport";
import { RapportFav, Rapport } from "@/shared/Rapport";
import RapportMixin from "@/mixins/rapportMixin";
import SelectedSites from "@/ui-component/selectedSites.vue";
import ErrorMixin from "@/mixins/errorMixins";
import { state } from "@/store/login";
import FiscalReportDialog from "@/components/FiscalReportDialog.vue";

@Component({
  components: {
    FiscalReportDialog,
    DateChooser,
    RapportSelection,
    ListeSites,
    PdfViewer,
    LocalChooser,
    SelectedSites,
  },
})
export default class Rapports extends mixins(RapportMixin, ErrorMixin) {
  @Prop({ default: false }) public isFavoris!: boolean;
  @Prop({ default: false }) public isRecurrence!: boolean;
  @Prop({ default: null }) public recRapport!: Rapport;
  public dialogError: boolean = false;
  public avReports: any = {
    PDF_AVAILABLE: false,
    CSV_AVAILABLE: false,
    TRANCHE_HORAIRE: false,
    FILTRES: [],
    TRIS: [],
    MULTI_CHOIX_FILTRES: false,
  };
  public pdfReport: PdfReport = new PdfReport();
  public showRep = false;
  public showExtracteur = false;
  public showFiscalReport = false;
  public dates = [
    new Date().toISOString().substr(0, 10),
    new Date().toISOString().substr(0, 10),
  ];
  public extracteurData = { site: -1, dateDebut: "", dateFin: "" };
  public menu = false;
  public handleSaveFilters(result: any) {
    this.updateSaveConditions(result.split(","));
  }
  public handleTris(result: any) {
    this.monTri = "";
    this.monrapport.tri = "";
    this.avReports.TRIS = result;
  }

  public handleCanSaveFilters(result: any) {
    this.rapport.isfilters = result;
  }

  public mounted() {
    // console.log(this.getReport.typeRapport.className, this.getReport.format);
    if (this.sites.length === 1) {
      this.monrapport.lSites = this.sites;
      this.updateRapport(this.getReport);
      this.extracteurData.site = this.sites[0].restaurantId;
    }
  }
  /**
   * methode permettant de faire disparaitre le datePicker
   */
  public closeDatePicker(show: boolean) {
    if (!show && this.dates[1] === undefined) {
      this.dates[1] = this.dates[0];
      this.updateDates();
    }
  }

  /**
   * méthode de mise à jour dans le rapport de la date de fin et de la date de début en fonction de la période selectionnée
   */
  public updateDates() {
    if (moment(this.dates[0]).isAfter(moment(this.dates[1]))) {
      this.extracteurData.dateDebut = moment(this.dates[1]).format(
        "YYYY-MM-DD"
      );
      this.extracteurData.dateFin = moment(this.dates[0]).format("YYYY-MM-DD");
    } else {
      this.extracteurData.dateDebut = moment(this.dates[0]).format(
        "YYYY-MM-DD"
      );
      this.extracteurData.dateFin = moment(this.dates[1]).format("YYYY-MM-DD");
    }
  }
  /**
   * methode d'affichage de la date de debut et de fin dans le selecteur du range picker
   */
  public getDatesStr() {
    if (this.dates.length === 2) {
      const deb = moment(this.dates[0]).format("DD/MM/YYYY");
      const fin = moment(this.dates[1]).format("DD/MM/YYYY");
      return `${this.$i18n.tc("from").toString()} ${deb} ${this.$i18n
        .tc("to")
        .toString()} ${fin}`;
    }
  }
  /**
   * méthode permettant de telecharger l'extracteur contenant l'ensemble des rapports necessaires à l'audit
   */
  public genererExtracteur() {
    if (this.extracteurData.dateDebut === "") {
      this.updateDates();
    }
    if (this.extracteurData.site === -1) {
      this.extracteurData.site = this.sites[0].restaurantId;
    }
    this.$store.dispatch("login/setLoading", true);
    this.$store.dispatch("rapport/getExtracteurData", this.extracteurData).then(
      (res: any) => {
        const blob = new Blob([res.data], {
          type: res.headers["content-type"],
        });
        const bloburl = (window.URL || window || {}).createObjectURL(blob);

        const a = document.createElement("a");
        document.body.appendChild(a);
        const fileLink = document.createElement("a");
        fileLink.href = bloburl;
        const titre =
          this.extracteurData.site +
          "_RapportsAudit_" +
          this.extracteurData.dateDebut +
          "_" +
          this.extracteurData.dateFin +
          ".zip";
        fileLink.setAttribute("download", titre);
        document.body.appendChild(fileLink);
        fileLink.click();
        this.$store.dispatch("login/setLoading", false);
        this.showExtracteur = false;
      },
      (error: any) => {
        this.setErrorFromTxt(error.toString());
      }
    );
  }

  get isCentral() {
    return this.$store.getters.getGlobal;
  }

  /**
   * methode permettant de faire disparaitre le dialogue contenant le rapport
   */
  public hide(target: any) {
    this.showRep = false;
  }
  /*
   * methode de mise a jour du rapport selectionné dans la page parente
   */
  public updateRapport(rapport: Rapport | RapportFav) {
    this.$emit("updateRapport", rapport);
  }

  get sites(): Site[] {
    return this.$store.getters["login/sites"];
  }

  get groupements(): Groupe[] {
    return this.$store.getters["login/groupements"];
  }

  get getReport(): Rapport {
    if (this.isRecurrence) {
      return this.recRapport;
    } else {
      return this.rapport;
    }
  }

  get rapport(): Rapport {
    let rap;
    if (this.isFavoris) {
      rap = this.$store.getters["rapport/selectedFavoris"];
    } else {
      rap = this.$store.getters["rapport/rapport"];
    }
    // console.log("get", rap);
    return rap;
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }

  get me(): any {
    return this.$store.getters["login/user"];
  }

  get global(): boolean {
    return this.$store.getters["getGlobal"];
  }
}
